import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
/*import { DesktopService } from '../../../services/desktop.service';*/
import { CobroService } from '../../../services/cobro.service';
import { PagoService } from '../../../services/pago.service';
import { GuiaremisionService } from '../../../services/guiaremision.service';
import { RetencionService } from '../../../services/retencion.service';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { FelectronicaService } from '../../../services/felectronica.service';
import { ComprasVsVentasComponent } from '../../../components/charts/compras-vs-ventas/compras-vs-ventas.component';
import { ClientesMasVentasComponent } from '../../../components/charts/clientes-mas-ventas/clientes-mas-ventas.component';
import { ProveedoresMasComprasComponent } from '../../../components/charts/proveedores-mas-compras/proveedores-mas-compras.component';
import { SucursalMasVentasComponent } from '../../../components/charts/sucursal-mas-ventas/sucursal-mas-ventas.component';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import { EmpresaService } from '../../../services/empresa.service';
//import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
//import moment = require('moment');
import * as moment from 'moment';
import { VentaService } from '../../../services/venta.service';
import { ProductoService } from '../../../services/producto.service';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { ProductosMasVendidosComponent } from '../../charts/productos-mas-vendidos/productos-mas-vendidos.component';

declare var $: any;

@Component({
    selector: 'desktop',
    templateUrl: './desktop.component.html',
    styleUrls: ['./desktop.component.css'],
    providers: [CobroService, PagoService, VentaService, EmpresaService, BsModalService, FelectronicaService, GuiaremisionService, RetencionService, NotaCreditoService,ProductoService]
})
export class DesktopComponent implements OnInit {
    @ViewChild(ComprasVsVentasComponent) comprasVsVentas: ComprasVsVentasComponent;
    @ViewChild(ProductosMasVendidosComponent) productosMasVendidos: ProductosMasVendidosComponent;
    @ViewChild(ClientesMasVentasComponent) clientesMasVentas: ClientesMasVentasComponent;
    @ViewChild(ProveedoresMasComprasComponent) proveedoresMasCompras: ProveedoresMasComprasComponent;
    @ViewChild(SucursalMasVentasComponent) sucursalMasVentas: SucursalMasVentasComponent;
    public total_cts_cobrar: number;
    public total_cts_pagar: number;
    public total_facturas: number;
    public total_retenciones: number;
    public total_guias: number;
    public total_notas: number;
    public bsModalRef: BsModalRef;
    public loading = false;
    public radioModel = "dia";
    public perfil_id: string;
    public msgSweet: SweetMessage;
    public empresa_id: String;
    public fecha_inicio;
    public fecha_fin;
    public Mod_FactElec: string;
    public limit: number;
    public order: string;
    constructor(
        private cobroService: CobroService,
        private ventaService: VentaService,
        private notaService: NotaCreditoService,
        private retencionService: RetencionService,
        private guiaService: GuiaremisionService,
        private pagoService: PagoService,
        private empresaService: EmpresaService,
        private ss: SessionService,
        public modalService: BsModalService,
        public productoService: ProductoService,
        public storage:AsyncLocalStorage,
    ) {
        this.fecha_inicio = moment(this.fecha_inicio).format("YYYY-MM-DD");
        this.fecha_fin = moment(this.fecha_fin).format("YYYY-MM-DD");
        this.total_cts_cobrar = 0;
        this.total_cts_pagar = 0;
        this.total_facturas = 0;
        this.total_retenciones = 0;
        this.total_guias = 0;
        this.total_notas = 0;
        this.perfil_id = this.ss.getData('perfil_id');
        this.empresa_id = this.ss.getData('empresa_id');
        this.msgSweet = new SweetMessage();
        this.Mod_FactElec = "";
        this.limit = 5;
        this.order = "DESC";
    }

    ngOnInit() {
        //DATA
        this.getData();
        this.getEmpresaById();
    }

    getEmpresaById() {
        this.Mod_FactElec = this.ss.getData("mod_felectronica");

        this.empresaService.getById(this.empresa_id).subscribe(
            res => {
                if (res.is_adeuda_valores == "1") {
                    this.isAdeudaValores(res);
                }
            }
        );
    }

    validateFechas() {
        return (this.fecha_inicio.toString().trim().length > 0 && this.fecha_fin.toString().trim().length > 0);
    }

    getData() {
        this.loading = true;
        let p1 = this.getFactura();
        let p2 = this.getRetencion();
        let p3 = this.getGuia();
        let p4 = this.getNota();

        Promise.all([p1, p2, p3, p4]).then(
            res => {
                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    onChangeBusqueda() {
        this.getData();
        this.comprasVsVentas.updateDataChart(this.radioModel, moment(this.fecha_inicio).format("YYYY-MM-DD"), moment(this.fecha_fin).format("YYYY-MM-DD"));
        this.productosMasVendidos.updateDataChart(this.radioModel, moment(this.fecha_inicio).format("YYYY-MM-DD"), moment(this.fecha_fin).format("YYYY-MM-DD"));
        this.clientesMasVentas.updateDataChart(this.radioModel, moment(this.fecha_inicio).format("YYYY-MM-DD"), moment(this.fecha_fin).format("YYYY-MM-DD"));
        this.proveedoresMasCompras.updateDataChart(this.radioModel, moment(this.fecha_inicio).format("YYYY-MM-DD"), moment(this.fecha_fin).format("YYYY-MM-DD"));
        this.sucursalMasVentas.updateDataChart(this.radioModel, moment(this.fecha_inicio).format("YYYY-MM-DD"), moment(this.fecha_fin).format("YYYY-MM-DD"));

        if (this.radioModel == "otro") {
            this.bsModalRef.hide();
        }
    }


    getFactura() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }

            this.ventaService.getAllDoc(qs).subscribe(
                res => {
                    this.total_facturas = res.count_ventas ? res.count_ventas : 0;
                    resolve(true);
                },
                err => {
                    this.total_facturas = 0;
                    reject();
                }
            );
        });
    }


    getRetencion() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }

            this.retencionService.getAllDoc(qs).subscribe(
                res => {
                    this.total_retenciones = res.count_retenciones ? res.count_retenciones : 0;
                    resolve(true);
                },
                err => {
                    this.total_retenciones = 0;
                    reject();
                }
            );

        });
    }


    getGuia() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }

            this.guiaService.getAllDoc(qs).subscribe(
                res => {
                    this.total_guias = res.count_guias ? res.count_guias : 0;
                    resolve(true);
                },
                err => {
                    this.total_guias = 0;
                    reject();
                }
            );

        });
    }

    getNota() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }

            this.notaService.getAllDoc(qs).subscribe(
                res => {
                    this.total_notas = res.count_notas ? res.count_notas : 0;
                    resolve(true);
                },
                err => {
                    this.total_notas = 0;
                    reject();
                }
            );


        });
    }

    getCtsXCobrar() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }
            this.cobroService.getTotalCtsXCobrar(qs).subscribe(
                res => {
                    this.total_cts_cobrar = res.data ? res.data : 0;
                    resolve(true);
                },
                err => {
                    this.total_cts_cobrar = 0;
                    reject();
                }
            );
        });
    }

    getCtsXPagar() {
        return new Promise((resolve, reject) => {
            let qs = "";
            if (this.radioModel == "otro") {
                qs = "?periodo=" + this.radioModel + "&fecha_inicio=" + moment(this.fecha_inicio).format("YYYY-MM-DD") + "&fecha_fin=" + moment(this.fecha_fin).format("YYYY-MM-DD");
            } else {
                qs = "?periodo=" + this.radioModel;
            }

            this.pagoService.getTotalCtsXPagar(qs).subscribe(
                res => {
                    this.total_cts_pagar = res.data ? res.data : 0;
                    resolve(true);
                },
                err => {
                    this.total_cts_pagar = 0;
                    reject();
                }
            );
        });
    }

    ngAfterViewInit() {
        this.initCirclePercentage();
    }

    initCirclePercentage() {
        $('#chartDashboard, #chartOrders, #chartNewVisitors, #chartSubscriptions, #chartDashboardDoc, #chartOrdersDoc').easyPieChart({
            lineWidth: 6,
            size: 160,
            scaleColor: false,
            trackColor: 'rgba(255,255,255,.25)',
            barColor: '#FFFFFF',
            animate: ({ duration: 5000, enabled: true })
        });
    }

    isAdeudaValores(empresa: any) {
        let msn = "";
        msn += "<div style='text-align: left !important;'>";
        msn += "<p style='text-align: center; color: rgb(202, 44, 44);'><i class='fa fa-exclamation-triangle'></i><b style='font-size:24px;'>Mensaje de Dinami</b></p>";
        msn += "<p>Estimado <b>" + empresa.nombre_comercial + "</b>, no hemos recibido el pago correspondiente <b>:(</b></p>";
        msn += "<p>Recuerde que puede realizar el pago a las siguientes cuentas: </p>";
        msn += "<p>Bco. Pichincha Cta. Cte. <b>#2100119866</b> <br>";
        msn += "Bco. Pacífico Cta. Cte. <b>#7929137</b> </p>";
        msn += "<p>A nombre de <b>Nextcode S.A.</b> y enviar el comprobante al correo <b>lchoez@nextcode.ec</b> o al WhatsApp <b>0961178934</b></p>";
        msn += "<p>Saludos.</p>";
        msn += "</div>";

        this.msgSweet.showMessage('single-message', msn);
    }
    openModal(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template, { class: 'second' });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/desktop/desktop/desktop.component.ts